/**
 * Created by lidonghua on 2018/4/8.
 */

import {apiUrl} from '../../utils/api'
import {init} from './init'

const configs = {
    //是否是白条用户
    CHECKLOUSUSER: {
        type: "CHECKLOUSUSER",
        url: apiUrl.checkLousUser,
        method: "checkLousUser",
        defaultState: {}
    },
    //用户信息
    USERINFOANDACTIVITY: {
        type: "USERINFOANDACTIVITY",
        url: apiUrl.getUserBaseInfoAndActivity,
        method: "userInfoAndActivity",
        defaultState: {}
    },
    //特卖列表
    SALELIST: {
        type: "SALELIST",
        url: apiUrl.queryBenefitSaleList,
        method: "saleList",
        defaultState: {}
    },
    //甄选
    RECOMMENDLIST: {
        type: "RECOMMENDLIST",
        url: apiUrl.qryBenefitList,
        method: "recommendList",
        defaultState: {}
    },
    //生活
    LIFELIST: {
        type: "LIFELIST",
        url: apiUrl.qryBenefitList,
        method: "lifeList",
        defaultState: {}
    }
}

// init state
export default init(configs);



// WEBPACK FOOTER //
// ./src/store/modules/index.js